import React from 'react';
import PropTypes from 'prop-types';
import OtpInput from 'react-otp-input';
import classNames from 'classnames';
import FormFeedback from './FormFeedback';
import './WrappedCodeInput.scss';

const WrappedCodeInput = ({
  input,
  meta,
  accept = false,
  reject = false,
  fields = 5,
  type = 'text',
  disabled = false,
  autoFocus = false,
  ...rest
}) => {
  const hasError = meta.error && meta.touched;

  // We move your dynamic classes to the containerStyle of the new library
  const containerClasses = classNames('form-code-input', {
    'form-code-input--accept': accept,
    'form-code-input--reject': reject,
    'form-code-input--error': hasError
  });

  return (
    <>
      <OtpInput
        {...rest}
        value={input.value || ''}
        onChange={(value) => input.onChange(value)}
        numInputs={fields}
        // 'tel' triggers the numeric keypad on mobile devices
        inputType={type === 'number' ? 'tel' : type}
        shouldAutoFocus={autoFocus}
        containerStyle={containerClasses}
        // This is the new requirement for the library: telling it how to draw the boxes
        renderInput={(props) => (
          <input {...props} disabled={disabled} onBlur={(e) => { props.onBlur && props.onBlur(e); input.onBlur(e); }} />
        )}
      />

      {/* Only show error after user has touched (interacted and blurred) the field */}
      {meta.error && meta.touched && (
        <div className="diary-lock__incorrect-message">
          <FormFeedback positive={false}>
            {meta.error}
          </FormFeedback>
        </div>
      )}
    </>
  );
};

WrappedCodeInput.propTypes = {
  accept: PropTypes.bool,
  reject: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  type: PropTypes.string,
  autoFocus: PropTypes.bool,
  fields: PropTypes.number,
  input: PropTypes.shape({
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool
  }).isRequired
};

export default WrappedCodeInput;
